'use strict';

// Logging
import LogRocket from 'logrocket';
LogRocket.init('gqns2e/rinble-mobile');


import Vue from 'vue';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
//@ts-ignore VueChatScroll is not typed, so let's make it ANY
import VueChatScroll from 'vue-chat-scroll';
import VModal from 'vue-js-modal';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import ApolloClient from 'apollo-client';
import gql from 'graphql-tag';
import { GraphQLClient } from 'graphql-request';
import { setContext } from 'apollo-link-context';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { split, concat } from 'apollo-link';
import App from '@/pages/app.vue';
import State from '@/vuex/appstate.js';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import 'babel-polyfill';
import VueRouter from 'vue-router';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css'
import SIPPlugin from '@/lib/SIPHandler';
import {routes} from '@/routes';
import Api from '@/api.js';

// Richard's note: TECHNICAL DEBT ELIMINATION TIME
//
// I'm factoring out the "global" variable. Anything which was unneccessarily in the
// global namespce is being moved to the top level of a module.
// const g:any = global;



async function init() {
  Vue.use(Vuetify);

  const router = new VueRouter({
    routes, // short for `routes: routes`
    //  history: true,
    //mode: 'history',
  })
  Vue.use(VueRouter);

  if (process.env.NODE_ENV == 'development') {
    const myUrl = new URL(window.origin);

    // API URL is port 80, index path
    myUrl.port = '80'; myUrl.pathname='/index.php';
    myUrl.searchParams.set('r', 'apiv1');
    global.apiurl = myUrl.href;

    // GraphQL URL is port 8000, /graphql
    //myUrl.searchParams.delete('r');
    //myUrl.port='8000'; myUrl.pathname='/graphql';
    //global.graphqlEndpoint = myUrl.href;

    // Websockets URL is protocol ws:, port 4000
    //myUrl.protocol='ws'; myUrl.port='4000';
    //global.graphqlWSEndpoint = myUrl.href;  
    
    global.apiurl = 'https://www.callerip.ca/index.php?r=apiv1';
    global.expressAPIUrl = 'https://api.rinble.com/api';
    //g.expressAPIUrl = 'http://localhost:8000/api';
    global.graphqlEndpoint = 'https://api.rinble.com/graphql';
    global.graphqlWSEndpoint = 'wss://ws.rinble.com/graphql';

    
    global.apiurl = 'https://www.callerip.ca/index.php?r=apiv1';
    global.graphqlEndpoint = 'http://localhost:8000/graphql';
    global.graphqlWSEndpoint = 'ws://localhost:4000/graphql';
    global.expressAPIUrl = 'http://localhost:8000/api';
    
    /* eslint no-console: off */
    console.log({
      msg: "Running in development mode. Using alternate URL's:", 
      api: global.apiurl,
      graphql: global.graphqlEndpoint,
      ws: global.graphqlWSEndpoint,
    });
  } else {
    global.apiurl = 'https://www.callerip.ca/index.php?r=apiv1';
    global.expressAPIUrl = 'https://api.rinble.com/api';
    global.graphqlEndpoint = 'https://api.rinble.com/graphql';
    global.graphqlWSEndpoint = 'wss://ws.rinble.com/graphql';
  }

  // make sure production people are https
  if ((location.hostname == 'messages.rinble.com') || (location.hostname == 'webphone.rinble.com') || (location.hostname == 'join.rinble.com')){
    if (location.protocol !== 'https:') {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
  }

  // Apollo & Graph QL
  // HTTP connexion to the API
  const httpLink = new HttpLink({
    // You should use an absolute URL here
    uri: global.graphqlEndpoint,
  });

  // Cache implementation
  const cache = new InMemoryCache()

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: (function() {
          return localStorage.getItem('authorizationToken');
        }()),
      }
    }
  });

  const wsLink = new WebSocketLink({ 
    uri: global.graphqlWSEndpoint,
    options: { 
      reconnect: true,
    },
  });


  const alink = split(
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    httpLink,
  );


  // Create the apollo client
  const apolloClient = new ApolloClient({
    link: concat(authLink, alink),
    cache,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
    },
    connectToDevTools: true,
  });

  // wsLink.subscriptionClient.maxConnectTimeGenerator.duration = () => wsLink.subscriptionClient.maxConnectTimeGenerator.max;


  const gqlClientFunction = function() {
    let at = localStorage.getItem('authorizationToken');
    if (at===null || at===undefined) {
      return new GraphQLClient(global.graphqlEndpoint, {});      
    }
    return new GraphQLClient(global.graphqlEndpoint, {
      headers: {
        authorization: at,
      },
    });
  };

  global.apollo = apolloClient;
  global.gqlClient = gqlClientFunction;
  global.gql = gql;
  global.api = new Api(global.gqlClient());

  Vue.use(VueResource);
  Vue.use(Vuex);
  Vue.use(VueChatScroll);
  Vue.use(VModal);

  // Register components
  Vue.component('font-awesome-icon', FontAwesomeIcon);

  library.add(fas);
  library.add(fab);

  const store = new Vuex.Store(State);
  Vue.use(SIPPlugin, { store });
  store.dispatch('setStateFromAuthToken');

  new Vue({ // eslint-disable-line no-new
    el: '#app',
    store,
    render: createElement => createElement(App),
    vuetify : new Vuetify({
      icons: {
        iconfont: 'mdi' // default - only for display purposes
      },
      theme: {
        themes: {
          dark: {
            primary: '#283593',
            accent: '#FF4081',
            secondary: '#ffe18d',
            success: '#4CAF50',
            info: '#2196F3',
            warning: '#FB8C00',
            error: '#FF5252'
          },
          light: {
            primary: '#292961',
            accent: '#e91e63',
            secondary: '#30b1dc',
            success: '#4CAF50',
            info: '#2196F3',
            warning: '#FB8C00',
            error: '#FF5252'
          }
        },
      },
    }),
    router,
  });
}

// We need to init the app.
if (global.cordova) {
  // If we're under cordova, wait for Cordova, and then init.
  document.addEventListener("deviceready", init, false);
} else {
  // Otherwise, just init.
  init();
}
